<template>
  <el-upload class="upload-demo" :id="id" :multiple="true" action="'' " :show-file-list="false" :on-change="onchangeFunc"  :http-request="uploadFiles" :limit="100" :file-list="fileList">
  </el-upload>
</template>

<script>
import { fileRes } from '@/api'
export default {
  name: 'v',
  data () {
    let id = `upla${new Date().getTime()}`
    return {
      fileList: [],
      id
    }
  },
  methods: {
    onchangeFunc (file, fileList) {
      this.fileList = fileList
    }, // 自定义上传
    uploadFiles (data) {
      console.log('上传')
      const fileInfo = {
        name: data.file.name
      }
      console.log(data)
      let formData = new FormData()
      formData.append('file', data['file'])
      fileRes.aloneUpload(formData).then(res => {
        fileInfo.path = res.filePath
        this.$emit('finished', {
          info: fileInfo
        })
      })
    },
    // 触发上传事件
    triggerUpload () {
      document.querySelector(`#${this.id} input`).click()
    }
  }
}
</script>

<style>

</style>
